/*
 * Copyright (c) 2024-2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export class Workload {
    date: Date;
    workload: number;
    role: string
    region: string;
    programName: string;
    milestoneName: string;

    constructor(date: Date, workload: number, role: string, region: string, programName: string, milestoneName: string) {
        this.date = date;
        this.workload = workload;
        this.role = role;
        this.region = region;
        this.programName = programName;
        this.milestoneName = milestoneName;
    }
}
